import { BNGPartners } from '~/partner.type'

export const usePartner = () => {
  const router = useRouter()
  const route = useRoute()
  const partner = computed(() => 'referer_code' in route.query ? route.query.referer_code as BNGPartners : BNGPartners.NONE)
  const layout = computed(() => 'referer_code' in router.currentRoute.value.query ? 'iframe' : 'default')

  return {
    partner,
    layout,
  }
}
